import {useSelector} from 'react-redux';
import {notificationType} from '../../../../utils/constant';
import Notification from './notification';

function AtDateDocumentNotificationsView() {
  const notifications = useSelector(globalState => globalState.notifications.notificationsWithActions.filter(({type}) => type === notificationType.DOCUMENT_AT_DATE));

  return (
    <div className="card-container-notifications">
      {notifications.map(notification => (
        <Notification
          key={`notification-${notification.notificationId}`}
          notification={notification}
        />
      ))}
    </div>
  );
}

export default AtDateDocumentNotificationsView;
